import { X, Search as SearchIcon } from 'react-feather';
import { Link } from 'react-router-dom';

import { useSearch } from '@/shared/hooks/useSearch';
import { useAuthStore } from '@/shared/stores/useAuthStore';
import { SearchProps } from '@/shared/types/SearchTypes';
import Button from '@/shared/components/UI/Button';
import LinkButton from '@/shared/components/UI/LinkButton';
import Input from '@/shared/components/UI/Input';
import { formatPrice } from '@/shared/utils/priceUtils';

const Search = ({ setSearchOpen }: SearchProps) => {
  const { searchTerm, setSearchTerm, searchResults, trimmedSearchTerm } =
    useSearch();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <div className="relative z-[300] h-[90px] w-full max-w-full bg-[#f3f3f3]">
      <div className="relative z-[300] h-[90px] w-full bg-[#f3f3f3]">
        <div className="mx-auto flex w-[34.25rem] items-center justify-between py-[23px]">
          <div className="relative w-[31.25rem]">
            <Input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mt-0 h-[44px] border-[#ccc] pl-[24px] pr-[52px] text-[14px]"
              fullWidth
            />
            <button
              type="button"
              className="absolute right-[24px] top-1/2 -translate-y-1/2 cursor-pointer bg-transparent"
            >
              <SearchIcon size={20} color="#444444" />
            </button>
          </div>
          <Button
            type="button"
            variant="secondary"
            size="icon"
            onClick={() => setSearchOpen(false)}
            className="h-[28px] w-[28px] rounded-full"
            leftIcon={<X color="white" size={16} />}
          />
        </div>
        <div className="mx-auto w-[35rem] rounded-b-[20px] bg-[#f3f3f3] px-[40px] py-[8px] pb-[40px] text-center">
          {searchResults.map((result) => (
            <Link
              to={`/productdetail/${result.optionUuid}`}
              onClick={() => setSearchOpen(false)}
              key={result.optionUuid}
              className="mb-[40px] flex cursor-pointer items-center gap-[16px] text-start"
            >
              <img
                src={result.thumbnailUrl}
                alt="thumbnail"
                className="h-[80px] w-[80px] rounded-[8px]"
              />
              <div>
                <h6 className="mb-[8px] flex-wrap text-[#222]">
                  {result.title}
                </h6>
                <p className="mb-[4px] text-[#666666]">{result.vendor}</p>
                <span className="mb-[8px] text-[0.875rem] font-extrabold text-[#444]">
                  {isAuthenticated
                    ? `${formatPrice(result.totalPrice, result.currencyCode)} ${result.currencySymbol}`
                    : 'Members Only'}
                </span>
              </div>
            </Link>
          ))}

          <LinkButton
            to={
              !trimmedSearchTerm || trimmedSearchTerm === ''
                ? `/productlist/0?tag=new&categoryName=NEW`
                : `/search?keyword=${trimmedSearchTerm}`
            }
            onClick={() => setSearchOpen(false)}
            variant="text"
            className="px-[12px] py-[4px] text-[12px] font-semibold text-[#444]"
          >
            VIEW ALL
          </LinkButton>
        </div>
      </div>
      <div className="fixed left-0 top-0 z-[200] h-[100vh] w-[100vw] bg-[#22222246]" />
    </div>
  );
};

export default Search;
